export default __webpack_public_path__ + "static/media/xls.33626b83.svg";